import fs from 'node:fs';
import { logImmediate } from '../log.js';

/** node-sqlite3-wasm advisory lock directory for a database file path. */
export function getSqliteLockPath(dbPath: string): string {
  return `${dbPath}.lock`;
}

/** Best-effort removal of a stale node-sqlite3-wasm lock directory (or file). */
export function removeSqliteLockPathIfPresent(dbPath: string): void {
  const lockPath = getSqliteLockPath(dbPath);
  try {
    fs.rmSync(lockPath, { recursive: true, force: true });
  } catch {
    /* ignore — teardown must not throw */
  }
}

export function logStaleSqliteLockIntervention(dbPath: string): void {
  const lockPath = getSqliteLockPath(dbPath);
  logImmediate(
    `SQLite database locked after retries; if no other buildautomaton CLI is running, remove stale lock: ${lockPath}`,
  );
}
